import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVerticalIcon, EnvelopeIcon, PencilSimpleIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerDetailMenu = ({ onEditCustomer, allowEditCustomer, onContactCustomer, allowSendEmail }) => {
  const { t } = useTranslation()

  const options = [
    {
      label: (
        <Styles.MenuOptionLabel>
          <EnvelopeIcon />
          {t('Contactar con el cliente')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onContactCustomer,
      disabled: !allowSendEmail,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <PencilSimpleIcon />
          {t('Editar datos del cliente')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onEditCustomer,
      disabled: !allowEditCustomer,
    },
  ]

  return (
    <ButtonMenu
      menuItems={options}
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          icon={<DotsThreeCircleVerticalIcon data-testid="menuButton" size={24} />}
        />
      )}
    />
  )
}

export default CustomerDetailMenu
